import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetQrCodeList(deviceId) {
  return maintainRequest({
    url: `/device/maintenanceMan/qrcode/getQrCodeList/${deviceId}`,
  });
}
